module.exports = __webpack_public_path__ + "img/glasses_male_square.168c5c10.png";